module.exports = __webpack_public_path__ + "static/media/landiscape-light.457f54b2.svg";